export type GraphServiceType = 'ping-link' | 'trafic';

export interface GraphPeriod {
  hours: number;
  label: string;
}

export const GRAPH_PERIODS: GraphPeriod[] = [
  {hours: 2, label: '2 heures'},
  {hours: 24, label: '24 heures'},
  {hours: 72, label: '3 jours'},
  {hours: 168, label: '7 jours'},
  {hours: 744, label: '31 jours'},
];

export const DEFAULT_GRAPH_PERIOD_HOURS = 24;
